export enum BackOfficeRole {
    SuperUser = 1,
    Administrator = 2,
    Moderator = 3
}
